import { render, staticRenderFns } from "./specialRemind.vue?vue&type=template&id=58ca3658&scoped=true&"
import script from "./specialRemind.vue?vue&type=script&lang=js&"
export * from "./specialRemind.vue?vue&type=script&lang=js&"
import style0 from "./specialRemind.vue?vue&type=style&index=0&id=58ca3658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca3658",
  null
  
)

export default component.exports